import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext, { getToken } from '../../../contexts/UserContext';
import ContentContext from '../../../contexts/ContentContext';

export default function Settings() {
    const navigate = useNavigate();
    const userCtx = useContext(UserContext);
    const contentCtx = useContext(ContentContext);

    useEffect(() => {
        contentCtx.updatePath([{ title: 'Settings', link: '/settings' }]);
    }, []);
    return (
        <div>Coming soon..

        </div>
    )
}
